import { createQueryParams } from '@/utils/query-params';
import type { UnitOfMeasure } from './inventory';
import { api } from './index';

export type ConsumptionPolicy = 'per_dose' | 'per_container';

// A generic medication of the global catalog. `inventoryItemId` is the item
// that already stocks it in the user's company, if any.
export interface ClinicalDrug {
  id: number;
  displayName: string;
  doseFormLabel: string;
  doseUnit: string;
  doseUnitLabel: string;
  defaultRoute: string;
  consumptionPolicy: ConsumptionPolicy;
  inventoryUnitOfMeasure: UnitOfMeasure | null;
  humanInventoryUnitOfMeasure: string | null;
  highAlert: boolean;
  inventoryItemId: number | null;
  // Active ingredients, to warn about the same one twice.
  substanceIds: number[];
}

// An active ingredient of the catalog, to name what a patient is allergic to.
export interface Substance {
  id: number;
  name: string;
}

export const clinicalDrugsApi = {
  search(q: string): Promise<ClinicalDrug[]> {
    return api.get(`/api/internal/clinical_drugs?${createQueryParams({ q })}`)
      .then((r) => r.data.clinicalDrugs);
  },
  searchSubstances(q: string): Promise<Substance[]> {
    return api.get(`/api/internal/substances?${createQueryParams({ q })}`)
      .then((r) => r.data.substances);
  },
};
